import { ColorScheme } from "../../../.storyblok/types/287059/storyblok-components";
import { fallbackColorScheme } from "../../helpers/colorSchemes";
import { getImageSource } from "../../helpers/getImageSource";
import { getStoryblokImageUrl } from "../../helpers/images/getStoryblokImageUrl";
import classNames from "classnames/bind";
import styles from "./ProductSquare.module.css";

const cx = classNames.bind(styles);

export const ProductSquare = ({
  colorScheme,
  imageUrl,
  imageAlt,
  title,
  redBullVersion,
}: {
  colorScheme: ColorScheme;
  imageUrl?: string;
  imageAlt?: string;
  title: string;
  redBullVersion?:
    | "original"
    | "sugarfree"
    | "zero"
    | "edition"
    | "edition-sugarfree"
    | undefined;
}) => {
  const shouldUseWhiteBackground =
    redBullVersion === "original" ||
    redBullVersion === "sugarfree" ||
    redBullVersion === "zero";

  const backgroundStyle = {
    "--productBackgroundColor": shouldUseWhiteBackground
      ? "#ffffff"
      : (colorScheme ?? fallbackColorScheme).secondaryColor,
    "--scheme-can-shadow-rgb": (colorScheme ?? fallbackColorScheme)
      .canShadowRGB,
  };

  const imageSource = imageUrl ? getImageSource(imageUrl) : null;

  return (
    <div style={backgroundStyle} className={cx("container")}>
      <h3 className={cx("title")}>{title}</h3>
      {imageUrl && (
        <>
          {imageSource === "storyblok" ? (
            <img
              className={cx("image")}
              src={getStoryblokImageUrl(imageUrl, {
                width: 352,
                height: undefined,
              })}
              alt={imageAlt}
            />
          ) : (
            <img
              style={backgroundStyle}
              className={cx("image")}
              src={imageUrl}
              alt={imageAlt}
            />
          )}
        </>
      )}
    </div>
  );
};
